export const initMenusDTO : MenusDTO = {
  label : "",
    value : '',
  sequence : 0,
  url : "",
  types : ["admin"]
}